import { useTranslation } from 'react-i18next'
import { KEY_LANGS, STORAGE_KEYS } from '@/shared/constants'
import { cn } from '@/shared/libs/cn'

const OPTIONS = [
  { label: 'VI', value: KEY_LANGS.VI },
  { label: 'EN', value: KEY_LANGS.EN },
]

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.resolvedLanguage === KEY_LANGS.EN ? KEY_LANGS.EN : KEY_LANGS.VI

  function handleLanguageChange(value: string) {
    const nextLanguage = value === KEY_LANGS.EN ? KEY_LANGS.EN : KEY_LANGS.VI
    localStorage.setItem(STORAGE_KEYS.LANGUAGE, nextLanguage)
    void i18n.changeLanguage(nextLanguage)
  }

  return (
    <div className="flex items-center gap-1 border border-zinc-200 rounded-lg p-1 bg-zinc-50">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => handleLanguageChange(opt.value)}
          className={cn(
            'px-3 py-1 rounded text-xs font-medium transition-colors',
            currentLanguage === opt.value
              ? 'bg-white shadow-sm text-zinc-900'
              : 'text-zinc-500 hover:text-zinc-700',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
